import { api } from "../api.ts";
import { CHANNEL_LABEL, STATUS_LABEL } from "../constants.ts";
import { ticketDisplayTitle } from "../utils/ticketDisplay.ts";
import type { MergeSuggestionCandidate, Ticket } from "../types.ts";

export function MergeSuggestBanner({
  newTicket,
  candidates,
  primaryId,
  canMerge,
  onPrimaryChange,
  onMerge,
  onDismiss,
}: {
  newTicket: Ticket;
  candidates: MergeSuggestionCandidate[];
  primaryId: number;
  canMerge: boolean;
  onPrimaryChange: (id: number) => void;
  onMerge: () => void;
  onDismiss: () => void;
}) {
  const mac = (newTicket.device_mac || "").trim();
  return (
    <div className="support-merge-suggest">
      <div className="support-merge-suggest__head">
        <strong>🔗 同一 MAC のチケットがあります</strong>
        <span className="support-merge-suggest__mac mono">{mac}</span>
      </div>
      <p className="support-merge-suggest__hint">
        今回起票した <span className="mono">{newTicket.ticket_number}</span> を、既存チケットへ統合することをおすすめします（重複対応の防止）。
      </p>
      <div className="support-merge-suggest__new">
        統合する（新規）: <span className="mono">{newTicket.ticket_number}</span> {ticketDisplayTitle(newTicket)}
      </div>
      <div className="support-merge-suggest__list">
        <span className="support-merge-suggest__label">存続先（primary）:</span>
        {candidates.map((c) => (
          <label key={c.id} className="support-merge-suggest__option">
            <input
              type="radio"
              name="merge-suggest-primary"
              checked={primaryId === c.id}
              onChange={() => onPrimaryChange(c.id)}
            />
            <span className="mono">{c.ticket_number}</span>
            <span>{ticketDisplayTitle(c as unknown as Ticket)}</span>
            <span className="support-merge-suggest__meta">
              {CHANNEL_LABEL[c.channel as keyof typeof CHANNEL_LABEL] || c.channel}
              {" · "}
              {STATUS_LABEL[c.status] || c.status}
            </span>
          </label>
        ))}
      </div>
      <div className="support-merge-suggest__actions">
        {canMerge ? (
          <button type="button" className="support-merge-suggest__merge" onClick={onMerge}>
            統合する
          </button>
        ) : (
          <span className="support-merge-suggest__readonly">統合は manager / super のみ実行できます</span>
        )}
        <button type="button" className="support-merge-suggest__dismiss" onClick={onDismiss}>
          後で
        </button>
      </div>
    </div>
  );
}

export async function fetchMergeSuggestions(mac: string, excludeTicketId: number) {
  const m = mac.trim();
  if (!m) return [] as MergeSuggestionCandidate[];
  const r = await api<{ candidates: MergeSuggestionCandidate[] }>(
    `/support/tickets/merge-suggestions?device_mac=${encodeURIComponent(m)}&exclude_ticket_id=${excludeTicketId}`,
  );
  return r.candidates || [];
}
